import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-772e10ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-form-cover" }
const _hoisted_2 = { class: "search_form__container" }
const _hoisted_3 = { class: "search_form__information" }
const _hoisted_4 = { class: "search_form__title" }
const _hoisted_5 = { class: "checkbox-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_TUIEditor = _resolveComponent("TUIEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "Perguntas: " + _toDisplayString(_ctx.currentPage) + "/" + _toDisplayString(_ctx.totalPages), 1)
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.question.question.title), 1),
      _createVNode(_component_TUIViewer, {
        "model-value": _ctx.question.question.description
      }, null, 8, ["model-value"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TUIEditor, {
          modelValue: _ctx.answerText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.answerText) = $event)),
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ])
    ])
  ]))
}